export const RequirementsGroupItemStatus = {
  Default: 'default',
  Fulfilled: 'fulfilled',
  Error: 'error',
} as const;

export type RequirementsGroupItemStatusType =
  (typeof RequirementsGroupItemStatus)[keyof typeof RequirementsGroupItemStatus];

export type RequirementsGroupItem = {
  /** Symbol or minimum value required (a single character or number, not a word). */
  leading: string;
  /** Short description of the requirement (one word or a short expression). */
  description: string;
  /** Visual state of the requirement. Defaults to `default`. */
  status?: RequirementsGroupItemStatusType;
};

export type RequirementsGroupProps = {
  /** One-line text describing the context of the requirements. */
  label: string;
  /** Requirements to display. A minimum of one item is expected. */
  items: RequirementsGroupItem[];
  /** Root `data-testid` for tests/e2e. */
  testId?: string;
};
